import { gql } from "apollo-boost";

export const CREATE_HOME_CLAIM = gql`
  mutation createHomeClaim(
    $user_id: ID!
    $property_id: ID!
    $email: String!
    $name: String
    $phone: String
  ) {
    create_home_claim(
      input: {
        user_id: $user_id
        property_id: $property_id
        email: $email
        name: $name
        phone: $phone
      }
    ) {
      ... on HomeClaim {
        id
      }
      ... on HomeClaimErrors {
        errors {
          message
          type
        }
      }
    }
  }
`;
